import entry from './entry';
import { SubmissionRankingService } from './SubmissionRankingService';

export default {
	...entry,
	'services.ranking.submissionRankingService': {
		class: SubmissionRankingService,
	},
};
